import React from "react";

const ServicePetrolier = () => {
  return (
    <>
      <main id="body-content">
        <section className="wide-tb-80">
          <div className="container pos-rel">
            <div className="row align-items-start">
              <div className="col-md-12 col-lg-8">
                <div className="row">
                  <div className="col-md-12 mb-5">
                    <div className="text-left">
                      <img
                        src="images/transpetro.jpg"
                        alt=""
                        className="rounded mb-4"
                      />
                      <h4 className="h4-md mb-3 txt-blue fw-7">
                        TRANSPORT DES PRODUITS PÉTROLIERS
                      </h4>
                      <p>
                        Propriétaire d'une flotte de camions citernes dont les
                        capacités sont de <strong>36 000 litres</strong> et{" "}
                        <strong>20 000 litres</strong>, nous transportons pour
                        le compte des entreprises de distribution des produits
                        pétroliers, le GPL, essence SUPER, Gasoil, Jet A1 au
                        départ de la Société Camerounaise des Dépôts Pétroliers
                        (SCDP) et la Société Nationale de Raffinage (SONARA)
                        pour toutes les villes du Cameroun et pour le Tchad et
                        la République Centrafricaine (RCA).
                      </p>

                      <h5 className="h5-md mt-5 mb-3 txt-blue fw-7">
                        Notre flotte de camions citernes
                      </h5>
                      <ul className="list-unstyled icons-listing theme-orange mb-0">
                        <li>
                          <i className="icofont-check"></i>Camions citernes de
                          36 000 litres
                        </li>
                        <li>
                          <i className="icofont-check"></i>Camions citernes de
                          20 000 litres
                        </li>
                        <li>
                          <i className="icofont-check"></i>Véhicules conformes
                          aux normes de sécurité internationales
                        </li>
                        <li>
                          <i className="icofont-check"></i>Maintenance régulière
                          et rigoureuse
                        </li>
                        <li>
                          <i className="icofont-check"></i>Équipements de
                          sécurité de dernière génération
                        </li>
                      </ul>

                      <h5 className="h5-md mt-5 mb-3 txt-blue fw-7">
                        Produits transportés
                      </h5>
                      <ul className="list-unstyled icons-listing theme-orange mb-0">
                        <li>
                          <i className="icofont-check"></i>
                          <strong>GPL</strong> (Gaz de Pétrole Liquéfié)
                        </li>
                        <li>
                          <i className="icofont-check"></i>
                          <strong>Essence SUPER</strong>
                        </li>
                        <li>
                          <i className="icofont-check"></i>
                          <strong>Gasoil</strong>
                        </li>
                        <li>
                          <i className="icofont-check"></i>
                          <strong>Jet A1</strong> (Carburant aviation)
                        </li>
                      </ul>

                      <h5 className="h5-md mt-5 mb-3 txt-blue fw-7">
                        Points de chargement
                      </h5>
                      <ul className="list-unstyled icons-listing theme-orange mb-0">
                        <li>
                          <i className="icofont-check"></i>
                          <strong>SCDP</strong> - Société Camerounaise des
                          Dépôts Pétroliers
                        </li>
                        <li>
                          <i className="icofont-check"></i>
                          <strong>SONARA</strong> - Société Nationale de
                          Raffinage
                        </li>
                      </ul>

                      <h5 className="h5-md mt-5 mb-3 txt-blue fw-7">
                        Zones de livraison
                      </h5>
                      <ul className="list-unstyled icons-listing theme-orange mb-0">
                        <li>
                          <i className="icofont-check"></i>Toutes les villes du
                          Cameroun
                        </li>
                        <li>
                          <i className="icofont-check"></i>République du Tchad
                        </li>
                        <li>
                          <i className="icofont-check"></i>République
                          Centrafricaine (RCA)
                        </li>
                      </ul>

                      <h5 className="h5-md mt-5 mb-3 txt-blue fw-7">
                        Sécurité et conformité
                      </h5>
                      <ul className="list-unstyled icons-listing theme-orange mb-0">
                        <li>
                          <i className="icofont-check"></i>Chauffeurs
                          spécialement formés au transport de matières
                          dangereuses
                        </li>
                        <li>
                          <i className="icofont-check"></i>Respect strict des
                          normes ADR (Accord européen relatif au transport de
                          marchandises Dangereuses par Route)
                        </li>
                        <li>
                          <i className="icofont-check"></i>Assurance tous
                          risques
                        </li>
                        <li>
                          <i className="icofont-check"></i>Suivi en temps réel
                          des livraisons
                        </li>
                        <li>
                          <i className="icofont-check"></i>Protocoles de
                          sécurité rigoureux
                        </li>
                        <li>
                          <i className="icofont-check"></i>Conformité avec la
                          réglementation nationale et internationale
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-4">
                <aside className="sidebar-spacer row">
                  <div className="sidebar-primary col-lg-12 col-md-6">
                    <div className="widget-wrap text-center bg-sky-blue rounded py-5">
                      <div className="mb-2">
                        <i className="icofont-headphone-alt icofont-4x"></i>
                      </div>
                      <h3 className="h3-md fw-5 txt-orange mb-4">
                        Besoin d'aide?
                      </h3>
                      <p>
                        Contactez notre
                        <br /> support technique 24/7
                      </p>
                      <a
                        href="/contact"
                        className="btn-theme bg-secondary mt-3"
                      >
                        Contacter <i className="icofont-rounded-right"></i>
                      </a>
                    </div>
                  </div>
                  <div className="sidebar-secondary col-lg-12 col-md-6">
                    <div className="widget-wrap">
                      <h3 className="h3-md fw-7 mb-4">Nos services</h3>
                      <div className="blog-list-categories">
                        <ul className="list-unstyled">
                          <li>
                            <a href="/servicedebours">Les Debours</a>
                          </li>
                          <li>
                            <a href="/serviceprestations">Les Prestations</a>
                          </li>
                          <li>
                            <a href="/servicedouane">Douane & Transit</a>
                          </li>
                          <li>
                            <a href="/servicetransport">
                              Transport & Logistique
                            </a>
                          </li>
                          <li className="active">
                            <a href="/servicepetrolier">
                              Transport Produits Pétroliers
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="widget-wrap">
                      <h3 className="h3-md fw-7 mb-4">Notre Photothèque</h3>
                      <ul className="photo-thumbs">
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-1.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-1.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-2.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-2.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-3.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-3.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-4.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-4.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-5.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-5.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-6.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-6.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-7.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-7.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-8.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-8.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-9.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-9.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
export default ServicePetrolier;
